module.exports = __webpack_public_path__ + "img/calendar.9af40a81.svg";